export default "__VITE_ASSET__60621ace__"